import React, { createContext, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { reSetPaymentOnBoard } from '../store/actions/payment/payment.action';

const NavContext = createContext({});

export const useNav = () => {
  return useContext(NavContext);
};

export const NavProvider = ({ children }: any) => {
  const dispatch = useDispatch();
  const [value, setValue] = React.useState({});
  const handleShowDropdown = (data: any) => {
    dispatch(reSetPaymentOnBoard());
    setValue(data);
  };

  const handleClose = () => {
    setValue({});
  };
  const propValue = {
    value,
    setValue,
    handleShowDropdown,
    handleClose
  };
  return <NavContext.Provider value={propValue}> {children}</NavContext.Provider>;
};
